import { InvalidInvitationDialog } from './InvalidInvitationDialog'
import { InvitationModal } from './InvitationModal'
import { useInvitationModal } from './useInvitationModal'

import type { JSX } from 'react'

/**
 * Mounts the invitation modal on app landing. Renders nothing unless the user
 * arrived with a pending invitation (via the `/invite/accept` redirect's router
 * state or a `?invite=` fallback). Drop this once near the app root, alongside
 * other on-load surfaces — it sits on top of whatever page the user lands on.
 *
 * A token that no longer resolves (expired/revoked/used) gets the blocking
 * invalid-invite dialog instead of silently rendering nothing (CORE-6244).
 */
export const InvitationModalContainer = (): JSX.Element | null => {
  const { invitation, isInvalid, isOpen, close } = useInvitationModal()

  if (isInvalid) {
    return <InvalidInvitationDialog open={isOpen} onClose={close} />
  }

  if (!invitation) {
    return null
  }

  return (
    <InvitationModal invitation={invitation} open={isOpen} onClose={close} />
  )
}
